const REGEX = /\B(?=(\d{3})+(?!\d))/g;

module.exports = { REGEX };
